module.exports = __webpack_public_path__ + "img/vote.87c7b0d3.png";